import FilterConstants from '../../../../filter-constants';
import * as CommonUtils from '../../../../utils/common';
import * as CircuitUtils from '../../../utils/circuit';

export function computeCapacitorLimitMultipliers(c1IdealValue, c2IdealValue, r1IdealValue, r2IdealValue) {
  let maxMultiplier = computeCapacitorMaximumLimitMultiplier(c1IdealValue, c2IdealValue, r1IdealValue, r2IdealValue);
  let minMultiplier = computeCapacitorMinimumLimitMultiplier(c1IdealValue, c2IdealValue, r1IdealValue, r2IdealValue);
  return {
    capacitorMinimumLimitMultiplier: minMultiplier,
    capacitorMaximumLimitMultiplier: maxMultiplier,
  };
}

export function computeGainResistorLimitMultipliers(r3IdealValue, r4IdealValue) {
  let minMultiplier = CircuitUtils.getResistorMinimumLimitMultiplier(r3IdealValue, r4IdealValue);
  let maxMultiplier = CircuitUtils.getResistorMaximumLimitMultiplier(r3IdealValue, r4IdealValue);
  return {
    resistorMinimumLimitMultiplier: minMultiplier,
    resistorMaximumLimitMultiplier: maxMultiplier,
  };
}

function computeCapacitorMaximumLimitMultiplier(c1IdealValue, c2IdealValue, r1IdealValue, r2IdealValue) {
  var cmax = Math.max(c1IdealValue, c2IdealValue);
  var result = FilterConstants.Limits.CBIG_COMP_LIMIT / cmax;
  var r1Tiny = r1IdealValue / result;
  var r2Tiny = r2IdealValue / result;

  if (CommonUtils.parallel(r1Tiny, r2Tiny) < FilterConstants.Limits.RSMALL_LOAD_LIMIT) {
    result = (result * CommonUtils.parallel(r1Tiny, r2Tiny)) / FilterConstants.Limits.RSMALL_LOAD_LIMIT;
  }

  return result;
}

function computeCapacitorMinimumLimitMultiplier(c1IdealValue, c2IdealValue, r1IdealValue, r2IdealValue) {
  var cmin = Math.min(c1IdealValue, c2IdealValue);
  var result = FilterConstants.Limits.CSMALL_COMP_LIMIT / cmin;
  var r1Big = r1IdealValue / result;
  var r2Big = r2IdealValue / result;

  var biggestR = Math.max(r1Big, r2Big);
  if (biggestR > FilterConstants.Limits.RBIG_COMP_LIMIT) {
    result = (result * biggestR) / FilterConstants.Limits.RBIG_COMP_LIMIT;
  }

  return result;
}
